export const GET_CONVERSATION_METRICS = 'GET_CONVERSATION_METRICS';
export const GET_QUERY_METRICS = 'GET_QUERY_METRICS';
export const GET_FEEDBACK_METRICS = 'GET_FEEDBACK_METRICS';
export const GET_TRAFFIC_SOURCES_METRICS = 'GET_TRAFFIC_SOURCES_METRICS';
